import { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
// constants
import { APP_ROUTES, TIMESACT_VERSION_2 } from "../../common/constants";
// contexts
import { VersionStoreContext } from "../../contexts/VersionStoreContext";
import NavigationMenuV1 from "./NavigationMenuV1";
import NavigationMenuV2 from "./NavigationMenuV2";

const NavigationMenu = () => {
  const { pathname } = useLocation();
  const { timesactVersion, isVersionLoaded } = useContext(VersionStoreContext);
  const memoizedV1 = useMemo(() => <NavigationMenuV1 />, []);
  const memoizedV2 = useMemo(() => <NavigationMenuV2 />, []);

  if (pathname.includes(APP_ROUTES.CUSTOMERS)) {
    return null;
  }

  if (!isVersionLoaded) {
    return;
  }

  if (timesactVersion && timesactVersion === TIMESACT_VERSION_2) {
    return memoizedV2;
  } else {
    return memoizedV1;
  }
};

export default NavigationMenu;
